import { fileToBase64DataUrl } from "@/utils/HTMLUtils";
import { capitalize, addSpacesBetweenWords } from "@/utils/string";

export const TABS = { GENERAL: 1, E_STORE: 3, BRAND_ACCESS: 4 };
export const DEFAULT_BRAND_COLOR = "#C1C1C1";
export const FORM_TYPE = { edit: "edit", create: "create" };
export const DEFAULT_COLORS = {
    linksColor: "#CCCCCC",
    backgroundColor: "#727A94",
    thirdColor: "#72727226",
    fourthColor: "#A8A8A8"
};

export function unserializeBrand(brand) {
    return {
        ...brand,
        orderShippingMethods: (brand.orderShippingMethods && brand.orderShippingMethods.map(method => method.id)) || []
    };
}

export async function serializeBrand(brand) {
    const logoBase64 = brand.logo && typeof brand.logo === "object" ? await fileToBase64DataUrl(brand.logo) : undefined;
    const heroImgBase64 = brand.heroImg && typeof brand.heroImg === "object" ? await fileToBase64DataUrl(brand.heroImg) : undefined;
    return {
        ...brand,
        currency: { id: brand.currency.id },
        orderShippingMethods: brand.orderShippingMethods.map(id => ({ id })),
        logoBase64,
        heroImgBase64
    };
}

/**
 * Generate form error messages with Fields missing
 * @param formName
 * @param form
 * @returns {string}
 */
export function generateFormErrorMessage(formName, form) {
    let res = "";
    const fieldsInForm = Object.keys(form);
    res += `<h1> - ${capitalize(addSpacesBetweenWords(formName)).replace(/form/gi, "")}</h1>`;
    for (const field of fieldsInForm) {
        const element = form[field];
        if (element.$invalid) res += `<p>${capitalize(addSpacesBetweenWords(field))}</p>`;
    }
    return res;
}



// WEBPACK FOOTER //
// ./src/components/admin/brand/utils/brandFormUtils.js